function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "7EC4B769-5C44-49F8-9C5C-20F171BCE501");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Financial-Aid-Packages",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "financialAidPackagesAddDocumentvMultiple",
  transform: "translate(-548.000000, -262.000000)"
}, React.createElement("g", {
  id: "addDocument",
  transform: "translate(424.000000, 131.000000)"
}, React.createElement("g", {
  id: "Fields_&_Inputs/Checkbox_+_Label/Small",
  transform: "translate(124.000000, 129.000000)"
}, React.createElement("g", {
  id: "Icon/Checkbox/Checked",
  transform: "translate(0.000000, 2.000000)"
}, React.createElement("polygon", {
  id: "24pt_Bounding_Box",
  opacity: 0,
  fillRule: "nonzero",
  points: "0 0 24 0 24 24 0 24"
}), React.createElement("path", {
  d: "M17.9999999,2.99999955 C19.6568497,2.99999955 20.9999999,4.34314955 20.9999999,5.99999955 L20.9999999,5.99999955 L20.9999999,17.9999995 C20.9999999,19.6568495 19.6568497,20.9999995 17.9999999,20.9999995 L17.9999999,20.9999995 L5.99999987,20.9999995 C4.34314987,20.9999995 2.99999987,19.6568495 2.99999987,17.9999995 L2.99999987,17.9999995 L2.99999987,5.99999955 L2.99999987,5.99999955 L3.00509258,5.82372723 C3.09633928,4.24892388 4.40232308,2.99999955 5.99999987,2.99999955 L5.99999987,2.99999955 Z M18,5.00000015 L5.99999996,5.00000015 C5.44771496,5.00000015 4.99999996,5.44771515 4.99999996,6.00000015 L4.99999996,6.00000015 L4.99999996,18.0000002 L4.99999996,18.0000002 L5.00672768,18.1166213 C5.06449276,18.61396 5.48716388,19.0000002 5.99999996,19.0000002 L5.99999996,19.0000002 L18,19.0000002 C18.552285,19.0000002 19,18.552285 19,18.0000002 L19,18.0000002 L19,6.00000015 C19,5.44771515 18.5522849,5.00000015 18,5.00000015 L18,5.00000015 Z M14.7727496,8.29440243 C15.1228894,7.93758173 15.6921589,7.88902093 16.1000001,8.2 C16.5418281,8.53689 16.6268941,9.168172 16.2900001,9.61 L16.2900001,9.61 L11.7200001,15.61 C11.5312071,15.855247 11.2394971,15.9992561 10.9300001,16.0000146 L10.9300001,16.0000146 L10.7993428,15.9921547 C10.541016,15.9595427 10.3035617,15.8269932 10.14,15.62 L10.14,15.62 L7.71000003,12.51 L7.71000003,12.51 L7.63901098,12.4061124 C7.38451695,11.978632 7.48225695,11.4185277 7.88500003,11.105 C8.32130503,10.765345 8.95034503,10.843695 9.29000003,11.28 L9.29000003,11.28 L10.92,13.39 L14.7,8.39 L14.6900001,8.39000002 L14.6900001,8.39000002 Z",
  id: "Fill"
}))))));

var SvgChecked = function SvgChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checked.264268d7.svg";
export { ForwardRef as ReactComponent };